import React from 'react';
import Stack from '@mui/material/Stack';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ruRU } from '@mui/x-date-pickers/locales';

export const StartTimePicker = ({
	value,
	onChange,
	disabled
}) => (
	<LocalizationProvider
		dateAdapter={AdapterDayjs}
		adapterLocale="ru"
		localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
		<Stack spacing={3} sx={{ mb: 3, mt: 2 }}>
			<DateTimePicker
				className="datetime-picker"
				label="Время начала обработки (необязательно)"
				value={value}
				onChange={onChange}
				disabled={disabled}
				slotProps={{ textField: { fullWidth: true } }}
				ampm={false}
				format="DD.MM.YYYY HH:mm"
			/>
		</Stack>
	</LocalizationProvider>
);